<div class="service-campaign-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container service-campaign-table-section">
    <article class="service-campaign-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Campaign List</p>
          <h2>Service Campaigns</h2>
        </div>
        <span class="badge-counter">{{ count || 0 }} records</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">Serial No.</th>
              <th scope="col">Service Image</th>
              <th scope="col">Service Category</th>
              <th scope="col">Service Name</th>
              <th scope="col">Campaign Price</th>
              <th scope="col">Start Date & Time</th>
              <th scope="col">End Date & Time</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of campaignList
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              "
            >
              <td data-label="Serial No.">{{ pageSize * (currentPage - 1) + i + 1 }}</td>
              <td data-label="Service Image">
                <img
                  class="imagtag"
                  src="{{ item?.serviceId?.userId?.profilePic }}"
                  alt=""
                />
              </td>
              <td data-label="Service Category">{{ item?.serviceId?.categoryId?.categoryName }}</td>
              <td data-label="Service Name">{{ item?.serviceId?.serviceName }}</td>
              <td data-label="Campaign Price">
                {{
                  item?.serviceDiscountedPrice
                    ? getPrice(
                        item?.serviceDiscountedPrice | currency: "ZAR":"R"
                      )
                    : item?.serviceDiscountedPrice || "--"
                }}
              </td>
              <td data-label="Start Date & Time">
                {{ item?.createdAt | date: "yyyy-MM-dd h:mm:ss a" || "--" }}
              </td>
              <td data-label="End Date & Time">
                {{ item?.endDate | date: "yyyy-MM-dd h:mm:ss a" || "--" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-table-loader
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="notFoundData"
        [colspan]="7"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="service-campaign-table-footer" *ngIf="count > pageSize">
        <pagination-controls (pageChange)="changePageNumber($event)">
        </pagination-controls>
      </div>
    </article>
  </section>
</div>
